export default __webpack_public_path__ + "static/502-bb28e16d76a3d9e7b9fd54ff1cf0c217.gif";